//#region Libraries
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
//#endregion
//#region Styles
import { Container } from "./styles";
//#endregion
//#region Components
import CustomDatePicker from "components/CustomDatePicker/CustomDatePicker";
import CustomTextInput from "components/CustomTextInput/CustomTextInput";
import CustomButton from "components/CustomButton/CustomButton";
import CustomSelect from "components/CustomSelect/CustomSelect";
//#endregion
//#region Images and Icons
import searchIcon from "img/search_icon.svg";
import TrashIcon from "icons/TrashIcon";
import OpenBookIcon from "icons/OpenBookIcon";
import { getOptionsToCustomSelect } from "components/CustomSelect/utils";
import { getDatePeriodFilters, DATE_PERIOD_FILTERS } from "./utils/constants";
import SearchIcon from "icons/SearchIcon";
import { requestGetWaitlistReport } from "services/events/aboutEvents";
import { EVENTS_CONSTANTS } from "config/constants";

import ABSOLUTE_PATHS from "routes/utils/absolutePaths"; 
//#endregion

const Filters = ({
	filters, fillEventList,
	resetCurrentPage,
	isTeacherUser, currentTabIdx, hasReportWaitlist
}) => {
	const navigate = useNavigate();
	const { title, date, organizerId } = filters.value;
	//#region States
	const [
		timeoutIdForDoRequestWithChangedTitle,
		setTimeoutIdForDoRequestWithChangedTitle,
	] = useState(null);
	const [customDatePeriod, setCustomDatePeriod] = useState({ ...DATE_PERIOD_FILTERS.GENERAL });
    //#endregion
    //#region Effects
    useEffect(() => {
        const DATE_PERIOD_FILTERS = getDatePeriodFilters(isTeacherUser);
        const newPeriod = DATE_PERIOD_FILTERS[currentTabIdx];
        setCustomDatePeriod(newPeriod);
    }, [currentTabIdx]);
	//#region Functions
	const changeTitleFilter = value => {
		if (value === title) return;
		filters.change("title", value);
		clearTimeout(timeoutIdForDoRequestWithChangedTitle);
		const timeoutId = setTimeout(() => {
			resetCurrentPage();
			fillEventList();
		}, 750);
		setTimeoutIdForDoRequestWithChangedTitle(timeoutId);
	};
	const changeDateFilter = value => {
		if (value === date) return;
		filters.change("date", value);
		resetCurrentPage();
		fillEventList();
	};
	const changeOrganizerFilter = value => {
		if (value === organizerId) return;
		filters.change("organizerId", value);
		resetCurrentPage();
		fillEventList();
	};
	const handleDownload = (base64Data) => {
		// Decodificar la cadena Base64 en un array de bytes
		const byteCharacters = atob(base64Data);
		const byteNumbers = new Array(byteCharacters.length).fill(0).map((_, i) => byteCharacters.charCodeAt(i));
		const byteArray = new Uint8Array(byteNumbers);
	
		// Crear un Blob con tipo MIME para Excel
		const blob = new Blob([byteArray], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
	
		// Crear una URL del Blob
		const blobUrl = URL.createObjectURL(blob);
	
		// Crear un enlace temporal y simular clic para descargar
		const link = document.createElement("a");
		link.href = blobUrl;
		link.download = EVENTS_CONSTANTS.FILENAME_REPORT_WAITLIST;
		document.body.appendChild(link);
		link.click();
	
		// Liberar memoria
		document.body.removeChild(link);
		URL.revokeObjectURL(blobUrl);
	  };
	const reportWaitlist = async () => {
		const report = await requestGetWaitlistReport();
		handleDownload(report);
	}
	//#endregion
	const { organizerList } = filters.data;
	return (
		<Container>
			<CustomTextInput
				placeholder="Buscar por nombre"
				width="400px"
				iconAdornment={<img src={searchIcon} />}
				value={title}
				onChange={changeTitleFilter}
			/>
			<CustomDatePicker
				placeholder="Buscar un evento por fecha"
				value={date}
				period={customDatePeriod}
				onChange={changeDateFilter}
			/>
			<CustomSelect
				defaultOptionText="Elige un organizador"
				value={organizerId}
				onChange={changeOrganizerFilter}
				optionsProps={getOptionsToCustomSelect(organizerList, {
					id: "id",
					text: "name",
				})}
			/>
			<CustomButton
				variant="secondary"
				size="small"
				disabled={filters.isCleared()}
				icon={<TrashIcon />}
				text="Limpiar"
				onClick={() => {
					filters.clear();
					fillEventList();
				}}
			/>

			{hasReportWaitlist && (
				<CustomButton
					variant="secondary"
					size="small"
					disabled={false}
					icon={<SearchIcon />}
					text="Reporte Lista Espera"
					onClick={() => reportWaitlist()}
				/>
			)}

			{/* <CustomButton
				variant="secondary"
				size="small"
				text="Cargar Alumnos"
				icon={<OpenBookIcon />}
				onClick={() => navigate(ABSOLUTE_PATHS.UPLOAD_STUDENT_LIST)} 
			/> */}
		</Container>
	);
};

export default Filters;
